Text.store.getters = {
};